import StorageService from "../Storage/storageService";
import { useAppSelector } from "./useAppSelector";

interface ReturnValues {
  token: Boolean;
  user: Boolean;
}

// this function checks if user token is present and user corresponding to token is valid
const useAuth = (): ReturnValues => {
  const token = StorageService.getFromLocalStorage("token");
  const loginToken = token?.accessToken; // TODO: will be fetched from constants
  const authUser = useAppSelector((state) => state.common.user);
  return {
    token: !!loginToken,
    user: !!authUser ?? ""
  };
};

export default useAuth;
